import React from 'react'
import Loader from 'react-loader-spinner'
import { withRouter } from 'react-router-dom'
import { pathMaker } from '../utils/useful';

class PageStatusViewer extends React.Component {



    state = {
        timer: 4,
    }

    startTimer() {
        if (!this.timer) {
            this.timer = setInterval(this.checkTimer, 1000);
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }

    checkTimer = () => {
        if (this.state.timer > 0) {
            this.setState({ timer: this.state.timer - 1 })
        } else {
            let search = this.props.location.search;
            let params = new URLSearchParams(search);
            let ref = params.get('ref');
            if (ref && ref !== '') {
                // console.log(ref)
                if (this.timer) {
                    clearInterval(this.timer)
                }
                this.props.history.push(ref)
            } else {
                if (this.timer) {
                    clearInterval(this.timer)
                }
                this.props.history.push(pathMaker('/'))
            }
        }
    }


    render() {
        if (!this.props.status) {

            return (
                <div className="mt-5 text-center w-100">
                    <Loader
                        type={this.props.type ?? "Oval"}
                        color={this.props.color ?? "#202020"}
                        height={this.props.width ?? 50}
                        width={this.props.height ?? 50}
                    />
                </div>
            )
        }

        if (this.props.status == 200) {
            return (
                <div style={{ backgroundColor: '#fff' }}>
                    {this.props.children}
                </div>
            )

        }

        if (this.props.status == 500) {
            return (
                <div className="text-center pt-5">
                    <img width={500} src='/images/icons2/500.svg' />
                    <p className="mb-2" style={{ color: '#222', fontSize: '25px', fontWeight: '600' }}>مشکل از سرور 500</p>
                    <p className="" style={{ color: 'red', fontSize: '14px', fontWeight: '300' }}>سرور وبسایت با شرایط غیرمنتظره‌ای مواجه شده که مانع از انجام درخواست شما می‌شود.</p>
                </div>
            )

        }


        if (this.props.status == 401) {
            this.startTimer()
            return (

                <div className="w-100 text-center flexc flex-column min-full-height">
                    <img className='' width={400} src='/images/icons2/401.svg' />
                    <p className="mb-2" style={{ color: '#222', fontSize: '25px', fontWeight: '600' }}>401 دسترسی غیرمجاز</p>
                    <p className="" style={{ color: 'red', fontSize: '14px', fontWeight: '300' }}>ما نتوانستیم اعتبار شما را تایید کنیم.</p>
                    <p className="" style={{ color: 'red', fontSize: '14px', fontWeight: '300' }}>لطفا از مدیر خود بخواهید برای شما دعوت نامه ارسال کند.</p>
                </div>
            )
        }


        if (this.props.status == 404) {
            return (
                <div className="w-100 mt-5 text-center">
                    <img className='w-100 px-3 px-md-0' style={{ maxWidth: 400 }} src='/images/icons2/404.svg' />
                    <p className="mb-2 px-2 px-md-0" style={{ color: '#222', fontSize: '25px', fontWeight: '600' }}>صفحه مورد نظر یافت نشد 402</p>
                    <p className="px-2 px-md-0" style={{ color: 'red', fontSize: '14px', fontWeight: '300' }}>صفحه ی مورد نظر یا دیگر در دسترس نیست یا آدرس را اشتباه وارد کرده اید.</p>
                </div>
            )
        }

    }
}

export default withRouter(PageStatusViewer);